import { render, staticRenderFns } from "./PanelInch65.vue?vue&type=template&id=f8c34498&scoped=true&"
import script from "./PanelInch65.vue?vue&type=script&lang=js&"
export * from "./PanelInch65.vue?vue&type=script&lang=js&"
import style0 from "./PanelInch65.vue?vue&type=style&index=0&id=f8c34498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c34498",
  null
  
)

export default component.exports